var React = require('react');

function ArrowR (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.81031 1.9179L6.4214 1.52899L7.19922 0.751176L7.58813 1.14008L6.81031 1.9179ZM10.6699 4.99969L11.0588 4.61079L11.4477 4.99969L11.0588 5.3886L10.6699 4.99969ZM7.36756 9.07988L6.97865 9.46878L6.20083 8.69097L6.58974 8.30206L7.36756 9.07988ZM1.33195 5.55053L0.781949 5.55058L0.78185 4.45058L1.33185 4.45053L1.33195 5.55053ZM7.58813 1.14008L11.0588 4.61079L10.281 5.3886L6.81031 1.9179L7.58813 1.14008ZM11.0588 5.3886L7.36756 9.07988L6.58974 8.30206L10.281 4.61079L11.0588 5.3886ZM10.67 5.54969L1.33195 5.55053L1.33185 4.45053L10.6699 4.44969L10.67 5.54969Z","fill":"currentColor"}));
}

ArrowR.defaultProps = {"width":"14","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = ArrowR;

ArrowR.default = ArrowR;
